import { ADD_CATEGORY, EDIT_CATEGORY, GET_CATEGORIES_LIST, GET_CATEOGRY } from './ApiConstants';
import api from './ApiHandler';

export interface CategoryRequest {
  page: number;
  limit: number;
  sortDirection?: number;
  sortBy?: string;
}

export const getCategoriesByPage = async (payload: CategoryRequest) => {
  return await api.get(GET_CATEGORIES_LIST, { params: { ...payload } });
};

export const createCategory = async (payload: any) => {
  return await api.post(ADD_CATEGORY, { ...payload });
};

export const editCategory = async (payload: any) => {
  return await api.post(EDIT_CATEGORY, { ...payload });
};

export const getCategory = async (payload: any) => {
  return await api.get(GET_CATEOGRY, { params: { ...payload } });
};
